// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1kley","col":"CardReaderDesc_col__13MgL","label":"CardReaderDesc_label__3rKKM"};